import SEOTable from 'container/SEOTools/components/SEOTable/SEOTable'
import { FC, useCallback } from 'react'
import { RefreshablePagesList } from '../../types'

import s from './Table.module.css'

type Props = {
  columns: any
  dataSource: RefreshablePagesList[]
  onPageChange: (page: number) => void
  totalRecords: number
  pageSize: number
  page: number
  selectedRowKeys: React.Key[]
  onRowSelect: (ids: React.Key[], records: RefreshablePagesList[]) => void
}

export const Table: FC<Props> = ({
  columns,
  dataSource,
  onPageChange,
  totalRecords,
  pageSize,
  page,
  selectedRowKeys,
  onRowSelect,
}) => {
  const getRowKey = useCallback(
    (row: RefreshablePagesList) => {
      return row.id
    },
    [dataSource]
  )

  return (
    <SEOTable
      rowKey={getRowKey}
      pagination={{
        onChange: onPageChange,
        position: ['bottomRight'],
        total: totalRecords,
        pageSize,
        showSizeChanger: false,
        current: page,
      }}
      dataSource={dataSource}
      columns={columns}
      rowSelection={{
        type: 'checkbox',
        selectedRowKeys,
        onChange: (ids, records) => {
          onRowSelect(ids, records)
        },
      }}
      rowClassName={() => s.row}
    />
  )
}
